import React from 'react';
import PropTypes from 'prop-types';

import previewStyles from './PropertyPreview.scss';
import Loader from '../../../components/Loader';

const PropertyPreview = ({ image, property, loading }) =>
  property ? (
    <div className={previewStyles.propertyPreviewContainer}>
      <div className={previewStyles.propertyPreviewImageContainer}>
        {loading ? <Loader /> : <img src={image} alt="property" height={160} />}
      </div>
      <div className={previewStyles.propertyDetailsContainer}>
        <h3 className={previewStyles.propertyPreviewAddress}>
          {property.name}
        </h3>
        <p className={previewStyles.propertyPreviewCity}>
          {`${property.city}, ${property.province}, ${property.postal}`}
        </p>
      </div>
    </div>
  ) : null;

PropertyPreview.propTypes = {
  image: PropTypes.string,
  property: PropTypes.shape({
    name: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    postal: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
};

PropertyPreview.defaultProps = {
  image: '',
  loading: false,
};

export default PropertyPreview;
